import React from "react";
import UserProfile from "./User";
import BusinessProfile, { BusinessPageUrl } from "./Business";
import { cardClassName } from "./styles";

export default function index() {
  return (
    <div>
      <div className="border-b border-zinc-300 pb-3 ">
        <div className="ml-12 border-l border-zinc-300 pl-4">
          <h1 className="text-2xl font-bold leading-tight tracking-tight text-zinc-800">Cuenta</h1>
        </div>
      </div>
      <div className="space-y-6">
        <div className={cardClassName}>
          <UserProfile />
        </div>
        <div className={cardClassName}>
          <BusinessProfile />
        </div>
        <BusinessPageUrl />
      </div>
    </div>
  );
}
